import { Button, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import { onDeleteAddUser } from '../handler/UserManagementHandler';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

function ConfirmDeleteNewOrgUserDialog({ openConfirmModal, argsAll }) {
    // Re-render when the translation dictionary loads/updates.
    useTranslationSubscription();

    const handleCloseConfirmModal = () => {
        argsAll.setOpenConfirmModal({ isOpen: false, userId: null });
    };

    const handleDeleteUser = () => {
        onDeleteAddUser(openConfirmModal.userId, argsAll);
    };

    return (
        <Dialog
            open={openConfirmModal.isOpen}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogContent>
                <div className="dialog-content">
                    {trI18n('USER12MSG005')}
                </div>
            </DialogContent>
            <DialogActions className="dialog-action-delete">
                <Button
                    className="dialog-button-delete"
                    variant="contained"
                    onClick={() => handleDeleteUser()}
                >
                    {trI18n('COMBTN002')}
                </Button>
                <Button
                    className="dialog-action-cancel"
                    variant="contained"
                    onClick={() => handleCloseConfirmModal()}
                >
                    {trI18n('COMBTN007')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default ConfirmDeleteNewOrgUserDialog;
